<template>
  <div class="slider">
    <b-row class="header">
      <b-col class="title" cols="7">
        {{ brand }} {{ make | fix }}
        <span v-if="model > 0">{{ model }}</span>
      </b-col>
      <b-col class="item" cols="3" sm="4">
        <span v-if="false">
          Partida
          <span class="no">{{ item }}</span>
        </span>
      </b-col>
      <b-col class="status" cols="2" sm="1">
        <Status :status="currentBidStatus" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <Slider
          :key="id"
          :id="id"
          :images="images"
          :sliderId="sliderId"
          :activeSlide="activeSlide"
        />
      </b-col>
    </b-row>
    <b-row class="row-slider-pics">
      <b-col
        cols="6"
        md="3"
        v-for="(image, index) in images"
        :key="image.id"
        v-on:click="changeSlide(index)"
      >
        <b-img-lazy :src="image | imageSizing('small')" fluid></b-img-lazy>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="1">&nbsp;</b-col>
      <b-col>
        <Icons :flags="flags" :align="iconsAlign" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Status from "./Status";
import Icons from "./Icons";
import Slider from "../utils/Slider";

export default {
  name: "ItemSlider",
  components: {
    Status,
    Icons,
    Slider,
  },
  props: {
    id: {
      type: String,
      default: "0",
    },
    model: {
      type: Number,
      default: 0,
    },
    base: {
      type: Number,
      default: 0,
    },
    brand: {
      type: String,
      default: "",
    },
    make: {
      type: String,
      default: "",
    },
    images: {
      type: Array,
      default: function () {
        return [];
      },
    },
    flags: {
      type: Object,
      default: function () {
        return {};
      },
    },
    status: {
      type: String,
      default: "on",
    },
    item: {
      type: Number,
      default: 0,
    },
    bidStatus: {
      type: String,
      default: "on",
    },
  },
  data() {
    return {
      sliderId: "item-slider",
      activeSlide: 0,
      dataBidStatus: "",
      iconsAlign: "left",
    };
  },
  filters: {
    imageSizing: function (image, size) {
      return (
        "https://db97aqbgbmp5i.cloudfront.net/images/inv/" +
        size +
        "/" +
        image
      );
    },
    fix: function (make) {
      return make === "SIN LINEA" ? "" : make;
    },
  },
  methods: {
    changeSlide: function (index) {
      this.activeSlide = index;
    },
  },
  computed: {
    currentBidStatus: function () {
      return this.dataBidStatus !== "" ? this.dataBidStatus : this.bidStatus;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/partial";

.slider {
  background-color: $white;
  height: 100%;
}

.row-slider-pics {
  margin-top: 10px;

  img {
    cursor: pointer;
  }
}

.header {
  font-size: 1.3rem;

  @media (max-width: prev-viewport-max-size("lg")) {
    font-size: 1.1rem;
  }

  @media (max-width: prev-viewport-max-size("md")) {
    font-size: 1rem;
  }

  @media (max-width: prev-viewport-max-size("xs")) {
    font-size: 0.8rem;
  }

  > * {
    &:first-child {
      margin-left: 0.4rem;
      margin-right: -0.4rem;
    }
  }
}

.title,
.no {
  font-weight: $font-weight-bold;
}

.status {
  text-align: right;
}

@media (max-width: prev-viewport-max-size("md")) {
  .row-slider-pics {
    > div[class^="col-"],
    div[class*=" col-"] {
      margin-top: 10px;

      &:first-child,
      &:nth-child(2) {
        margin-top: 0;
      }
    }
  }
}
</style>
